export default __webpack_public_path__ + "static/media/pg.abc81ff9.svg";